import moment from 'moment';
import { provinceAreaMonthVolumes, provinceAreaPeriodVolumes } from '@/services/api';
import { getData } from '@/components/report/service';
import { computeWeight } from '@/utils/query';
import { TableQuery } from '../Filter';
import { recombinationData, mergeData } from '@/utils';
import { GetProvinceArea } from '@/services/area';

const paramsForm = {
  // startDate: moment(new Date()).add(-1, 'days').format('YYYY-MM-DD'),
  // endDate: moment(new Date()).add(0, 'days').format('YYYY-MM-DD'),
  provinceArea: undefined, // 省区 { name: '浙江经营本部'},
  scanSite: undefined, // { name: '萧山分拨中心'}, // 分拨
  timeType: 3
}

export default {
  namespace: 'volumeCapacityMatching',
  state: {
    filter: { ...paramsForm },
    defualtDateFormat: 'YYYY-MM-DD',

    tableColumns: [], // table header
    destinationProvinceAreas: [], // 目的省份
    tableItem: [],

    tableOffsetHeight: 0
  },
  effects: {
    *resetSearch(_, { put }) {
      // 重置
      yield put({
        type: 'update',
        payload: {
          filter: { ...paramsForm }
        },
      });
    },
    *getTableDate(_, { call, put, select }) {
      let query = yield select(({ volumeCapacityMatching }) => {
        const filer = volumeCapacityMatching.filter;
        return {
          timeType: filer.timeType,
          provinceArea: filer.provinceArea ? filer.provinceArea.name : null,
          scanSite: filer.scanSite ? filer.scanSite.name : null,
          tableColumns: volumeCapacityMatching.tableColumns,
          destinationProvinceAreas: volumeCapacityMatching.destinationProvinceAreas
        }
      });
      let startDate;
      let endDate;
      if (query.timeType === 3) {
        startDate = moment(new Date()).add(-1, 'days').format('YYYY-MM-DD 12:00:00');
        endDate = moment(new Date()).add(0, 'days').format('YYYY-MM-DD 12:00:00');
      } else if (query.timeType === 2) {
        startDate = moment().startOf('month').format('YYYY-MM-DD 00:00:00');
        endDate = moment().endOf('month').format('YYYY-MM-DD 23:59:59');
      } else if (query.timeType === 1) {
        startDate = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD 00:00:00');
        endDate = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD 23:59:59');
      }
      const baseFilter = TableQuery({
        startDate: startDate,
        endDate: endDate,
        originProvinceArea: query.provinceArea,
        originSiteName: query.scanSite,
        destinationProvinceAreas: query.destinationProvinceAreas
      })
      // 获取始发省区列表
      const data = yield call(getData, baseFilter[0]);
      if (data.length > 0) {
        const newData = [];
        const originProvinceAreas = [];
        const totalTable = [
          { originProvinceArea: '合计', type: '开单', index: 't-index' }
        ];
        let culumnTotal = 0;
        data.forEach(item => {
          if (item.originProvinceArea) {
            const obj = query.tableColumns.find(item2 => item.originProvinceArea === item2.title);
            const code = obj ? obj.code : 0;
            item.code = code;
            totalTable[0][`area_${code}`] = computeWeight(item.calcWeight);
            culumnTotal += item.calcWeight
            newData.push(item)
            originProvinceAreas.push(item.originProvinceArea)
          }
        })
        totalTable[0]['total'] = computeWeight(culumnTotal);
        let departure;
        if (query.timeType === 3) {
          // 按天
          const start = moment(startDate).day();
          departure = yield call(provinceAreaPeriodVolumes, {
            period: start === 0 ? 7 : start
          });
        } else {
          // 按月
          departure = yield call(provinceAreaMonthVolumes, {
            month: moment(startDate).format('YYYY-MM-DD')
          });
        }
        const volumeItem = departure.data && departure.data.length > 0 ? departure.data : []
        volumeItem.forEach(item => {
          const obj = query.tableColumns.find(item2 => item.departureProvinceArea === item2.title)
          if (obj) {
            const code = obj.code;
            item[`code`] = code;
          }
        })
        const newVolumes = [];
        const volumnTable = [
          { originProvinceArea: '合计', type: '运力', total: 0, index: 'v-index' }
        ];
        volumeItem.forEach(item => {
          const obj = data.find(item2 => item2.originProvinceArea === item.arrivalProvinceArea);
          if (obj) {
            newVolumes.push(item);
          }
        })
        const newVolumeItem = recombinationData(newVolumes, 'arrivalProvinceArea');
        newVolumeItem.forEach((item, index) => {
          item.index = 'b' + index;
          let totalVolume = 0;

          item.child.forEach(item2 => {
            if (item2.code) {
              item[`area_${item2.code}`] = item2.volume;
              const obj = query.tableColumns.find(item3 => item2.arrivalProvinceArea === item3.title);
              item.code = obj ? obj.code : null;
              if (obj.code !== item2.code) {
                totalVolume += item2.volume;
              }
            }
          })
          item.type = '运力';
          item.total = totalVolume;
          item.originProvinceArea = item.arrivalProvinceArea;
        })
        newVolumeItem.forEach(item => {
          volumnTable[0][`area_${item.code}`] = item[`area_${item.code}`];
          volumnTable[0].total += item[`area_${item.code}`];
        })

        const filter = TableQuery({
          startDate: startDate,
          endDate: endDate,
          originProvinceArea: query.originProvinceArea,
          originSiteName: query.scanSite,
          originProvinceAreas: originProvinceAreas, // 始发
          destinationProvinceAreas: query.destinationProvinceAreas // 目的
        })
        const data2 = yield call(getData, filter[1]);
        newData.forEach(item => {
          const arr = [];
          let total = 0;
          data2.forEach(item2 => {
            if (item.originProvinceArea === item2.originProvinceArea) {
              const obj = query.tableColumns.find(item3 => item3.title === item2.destinationProvinceArea);
              if (obj) {
                const code = obj.code;
                item2.code = obj.code;
                item[`area_${code}`] = computeWeight(item2.calcWeight);
                if (obj.code !== item.code) {
                  total += item2.calcWeight;
                }
              }
              arr.push(item2)
            }
          })
          item.child = arr;
          item.type = '开单';
          item.total = computeWeight(total);
        })
        newData.forEach((item, index) => {
          item.index = 'a' + index;
        })
        let newTable = [...newData, ...newVolumeItem];
        newTable.sort((item1, item2) => {
          if (item1.originProvinceArea && item2.originProvinceArea) {
            const index = item1.originProvinceArea.localeCompare(item2.originProvinceArea, 'zh-CN');
            if (index === 0) {
              let ratio;
              if (item2.type === '开单') {
                ratio = ((item2.total / item1.total) * 100).toFixed(2) + '%';
              } else {
                ratio = ((item1.total / item2.total) * 100).toFixed(2) + '%';
              }
              item1.ratio = ratio;
              item2.ratio = ratio;
            }
            return index
          } else {
            return false;
          }
        })
        if (totalTable[0].total > 0 && volumnTable[0].total > 0) {
          const ratio = ((totalTable[0].total / volumnTable[0].total) * 100).toFixed(2) + '%';
          totalTable[0].ratio = ratio;
          volumnTable[0].ratio = ratio;
        }
        if (!query.provinceArea) {
          newTable = [...newTable, ...totalTable, ...volumnTable]
        }
        yield put({
          type: 'update',
          payload: {
            tableItem: newTable,
          },
        });
      } else {
        yield put({
          type: 'update',
          payload: {
            tableItem: [],
          },
        });
      }
    },
    *setColumns(_, { call, put }) {
      // 获取省区，根据省份生成table头部column
      const data = yield call(GetProvinceArea);
      if (data.length > 0) {
        const arr = [];
        const arr2 = [];
        data.forEach(item => {
          arr.push({
            title: item.name,
            code: item.code,
            dataIndex: `area_${item.code}`,
            align: 'center',
            ellipsis: true,
            width: 100,
            render: (t, r) => {
              if (r.originProvinceArea !== '合计' && r.originProvinceArea === item.name) {
                // return '--'
                return '--'
              } else {
                return t
              }
            }
          })
          arr2.push(item.name)
        });
        arr.sort((item1, item2) => {
          return item1.title.localeCompare(item2.title, 'zh-CN');
        })
        yield put({
          type: 'update',
          payload: {
            tableColumns: arr,
            destinationProvinceAreas: arr2
          },
        });
      }
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    }
  }
}
